import { render, staticRenderFns } from "./icon-order-completed.vue?vue&type=template&id=0acb86b2&scoped=true&"
import script from "./icon-order-completed.vue?vue&type=script&lang=js&"
export * from "./icon-order-completed.vue?vue&type=script&lang=js&"
import style0 from "./icon-order-completed.vue?vue&type=style&index=0&id=0acb86b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acb86b2",
  null
  
)

export default component.exports